// Shared, anchored Policy ID matcher. Format: <9-digit account>-<type><optseq>-<3-digit seq>-<2-char carrier>
// e.g. "843048918-AUTO-009-BX". Case-insensitive because agents paste IDs with an uppercase type.
// This is the single source of truth for the pattern; search-store.js imports it too.
export const POLICY_ID_REGEX = /^[0-9]{9}-[a-z]{4}[0-9]*-[0-9]{3}-[A-Z]{2}$/i;

export const POLICIES_ROUTE = '/search/policies';

// Only these tabs auto-switch to Policy. Deliberately excludes the Policy tab itself (no redirect
// loop) and the internal-agent Branch Plus tab (/search/branch-plus) — an agent searching the
// external-carrier index shouldn't be yanked away just because their term looks like a Branch
// policy ID. Matches the confirmed scope: switch from the Offer and Member tabs only (#34584).
export const AUTO_SWITCH_SOURCE_ROUTES = ['/search/offers', '/search/customers'];

// True when the entire (trimmed) search term is a single, complete Policy ID. The regex is anchored,
// so partially-typed IDs and multi-token searches (e.g. "john 843048918-AUTO-009-BX") never match —
// which is what keeps the auto-switch from firing mid-typing.
export function isPolicyId(searchString) {
  if (typeof searchString !== 'string') {
    return false;
  }
  return POLICY_ID_REGEX.test(searchString.trim());
}

// Decides whether typing/pasting `searchString` should auto-switch the Staff search to the Policy tab.
// Returns the target route (with the term preserved as a `search` query param, so the existing
// inbound-query flow repopulates the field and re-runs the search) or null when no switch is needed —
// i.e. the term isn't a Policy ID, or the current tab isn't one we switch away from.
export function policySearchRedirect(searchString, pathname) {
  if (!isPolicyId(searchString)) {
    return null;
  }
  if (!AUTO_SWITCH_SOURCE_ROUTES.includes(pathname)) {
    return null;
  }
  return `${POLICIES_ROUTE}?search=${encodeURIComponent(searchString.trim())}`;
}
